export default __webpack_public_path__ + "images/iconMenu.9e268482089142effcf239260f86bc38.svg"